export enum ClientsPermission {
  CreateClient = 'CreateClient',
  ReadAllClients = 'ReadAllClients',
  DeleteFolderAndAttachmentsClient = 'DeleteFolderAndAttachmentsClient',
  UpdateAdvisorClient = 'UpdateAdvisorClient',
  InactiveClient = 'InactiveClient',
  UpdateClient = 'UpdateClient',
  DeleteClient = 'DeleteClient',
  FieldRiskLevelClient = 'FieldRiskLevelClient'
}

export enum NegotiationsPermission {
  CreateNegotiation = 'CreateNegotiation',
  ReadAllNegotiations = 'ReadAllNegotiations',
  ActivateNegotiation = 'ActivateNegotiation',
  RescindApprovedNegotiation = 'RescindApprovedNegotiation',
  UpdateAdvisorNegotiation = 'UpdateAdvisorNegotiation',
  UpdateNegotiation = 'UpdateNegotiation',
  DeleteFolderAndAttachmentsNegotiation = 'DeleteFolderAndAttachmentsNegotiation',
  ExportJSONFEIC = 'ExportJSONFEIC',
  FieldUbicationNegotiation = 'FieldUbicationNegotiation',
  FieldRiskLevelNegotiation = 'FieldRiskLevelNegotiation',
  // Campos restringidos del acuerdo de pago (valores sin impuestos)
  FieldAmountsWithoutTaxNegotiation = 'FieldAmountsWithoutTaxNegotiation',
  // Permisos para impresión de documentos/contratos
  PrintFEIC = 'PrintFEIC',
  PrintEquityStatement = 'PrintEquityStatement',
  PrintExtendedDueDiligence = 'PrintExtendedDueDiligence',
  PrintProductionOrder = 'PrintProductionOrder',
  PrintPaymentAgreement = 'PrintPaymentAgreement',
  PrintPromise = 'PrintPromise',
  PrintReferralNegotiation = 'PrintReferralNegotiation',
  PrintSpecialGuidelines = 'PrintSpecialGuidelines',
  PrintSellClosure = 'PrintSellClosure',
  PrintPurchaseAgreement = 'PrintPurchaseAgreement',
  PrintQuoteMaintenance = 'PrintQuoteMaintenance'
}

export enum DeliveriesPermission {
  CreateDelivery = 'CreateDelivery',
  UpdateDelivery = 'UpdateDelivery',
  ReadAllDeliveries = 'ReadAllDeliveries', // existía solo en BE — añadido a paquete compartido
  MarkDeliveryAsCompleted = 'MarkDeliveryAsCompleted',
  MarkDeliveryAsPending = 'MarkDeliveryAsPending'
}

export enum UsersPermission {
  CreateUsers = 'CreateUsers',
  ReadUsers = 'ReadUsers',
  UpdateUsers = 'UpdateUsers',
  DeleteUsers = 'DeleteUsers'
}

export enum RolesPermission {
  CreateRoles = 'CreateRoles',
  ReadRoles = 'ReadRoles',
  UpdateRoles = 'UpdateRoles',
  DeleteRoles = 'DeleteRoles'
}

export enum CompaniesPermission {
  CreateCompanies = 'CreateCompanies',
  ReadCompanies = 'ReadCompanies',
  UpdateCompanies = 'UpdateCompanies',
  DeleteCompanies = 'DeleteCompanies'
}

export enum SocietiesPermission {
  CreateSocieties = 'CreateSocieties',
  ReadSocieties = 'ReadSocieties',
  UpdateSocieties = 'UpdateSocieties',
  DeleteSocieties = 'DeleteSocieties'
}

export enum ProjectsPermission {
  CreateProjects = 'CreateProjects',
  ReadProjects = 'ReadProjects',
  UpdateProjects = 'UpdateProjects',
  DeleteProjects = 'DeleteProjects'
}

export enum TypePropertiesPermission {
  CreateTypeProperties = 'CreateTypeProperties',
  ReadTypeProperties = 'ReadTypeProperties',
  UpdateTypeProperties = 'UpdateTypeProperties',
  DeleteTypeProperties = 'DeleteTypeProperties'
}

export enum PropertiesPermission {
  CreateProperties = 'CreateProperties',
  ReadProperties = 'ReadProperties',
  UpdateProperties = 'UpdateProperties',
  DeleteProperties = 'DeleteProperties'
}

export enum AgenciesPermission {
  CreateAgencies = 'CreateAgencies',
  ReadAgencies = 'ReadAgencies',
  UpdateAgencies = 'UpdateAgencies',
  DeleteAgencies = 'DeleteAgencies'
}

export enum RepresentantsPermission {
  CreateRepresentants = 'CreateRepresentants',
  ReadRepresentants = 'ReadRepresentants',
  UpdateRepresentants = 'UpdateRepresentants',
  DeleteRepresentants = 'DeleteRepresentants'
}

export enum CountriesPermission {
  CreateCountries = 'CreateCountries',
  ReadCountries = 'ReadCountries',
  UpdateCountries = 'UpdateCountries',
  DeleteCountries = 'DeleteCountries' // existía solo en FE — añadido a paquete compartido
}

export enum StatesPermission {
  CreateStates = 'CreateStates',
  ReadStates = 'ReadStates',
  UpdateStates = 'UpdateStates',
  DeleteStates = 'DeleteStates'
}

export enum StateTransitionPermission {
  ReadStateTransition = 'ReadStateTransition',
  ExecuteStateTransition = 'ExecuteStateTransition',
  EditStateTransition = 'EditStateTransition'
}

export enum WorkflowsPermission {
  CreateWorkflows = 'CreateWorkflows',
  ReadWorkflows = 'ReadWorkflows',
  UpdateWorkflows = 'UpdateWorkflows',
  DeleteWorkflows = 'DeleteWorkflows'
}

export enum ProfessionsPermission {
  CreateProfessions = 'CreateProfessions',
  ReadProfessions = 'ReadProfessions',
  UpdateProfessions = 'UpdateProfessions',
  DeleteProfessions = 'DeleteProfessions'
}

/**
 * Curaduría del cartapacio del cliente (ADR 0023).
 *
 * NINGUNO cuelga del CRUD de catálogo, y no es por gusto: nadie tiene
 * `UpdateSocieties`, y de los cinco equipos que el negocio designó para llenar el
 * cartapacio sólo uno tiene `UpdateProjects`. Ese mapa describe quién mantiene
 * datos de catálogo, no quién cura documentos.
 *
 * Dos permisos para los CUATRO niveles de catálogo y no ocho: los equipos se
 * organizan por categoría de documento, no por nivel.
 */
export enum DocumentsPermission {
  /** Subir, organizar, renombrar y anotar en sociedad, proyecto, subtipo e inmueble. */
  ManageCatalogDocuments = 'ManageCatalogDocuments',
  /** El flip a `visibility: public`. Llega al teléfono de cada cliente del nivel. */
  PublishCatalogDocuments = 'PublishCatalogDocuments',
  /**
   * El árbol del expediente: nodos propios y ajustes de lo heredado.
   *
   * Propio y no `UpdateNegotiation` porque el ciclo de vida de los documentos
   * SOBREVIVE al de la negociación: el cliente ve su inmueble cuando la venta se
   * aprueba, y desde ahí siguen entrando manuales, IUSI, entrega y postventa.
   */
  ManageNegotiationDocuments = 'ManageNegotiationDocuments'
}

/**
 * La administración de la APP MÓVIL del cliente: cuentas, accesos y sesiones.
 *
 * ── POR QUÉ NO SE REUSA `ClientsPermission.UpdateClient` ─────────────────────
 *
 * Que es lo que hacían las cinco escrituras hasta acá. `UpdateClient` es el permiso de
 * trabajo de TODO el que edita un expediente, así que reusarlo significa que quien
 * corrige un teléfono puede además abrir una cuenta móvil, concederle acceso a un
 * inmueble y disparar un correo a una persona real. Un correo enviado no se deshace.
 *
 * Es la misma asimetría que el ADR 0023 ya resolvió separando subir de publicar: el acto
 * que sale del sistema pide su propio permiso.
 *
 * ── POR QUÉ SON TRES Y NO UNO ────────────────────────────────────────────────
 *
 * Con un solo permiso no se puede dar VISIBILIDAD DE SÓLO LECTURA. Soporte necesita abrir
 * la pantalla para contestar «¿por qué el cliente no ve su inmueble?», y con un permiso
 * único dárselo le daría también el botón de bloquear.
 *
 * Y bloquear va aparte de gestionar porque es una decisión de SEGURIDAD que un flujo de
 * negocio no puede revertir: `release-mobile-access` lo respeta hoy —una cuenta bloqueada
 * no se reactiva sola al aprobar una venta— y tener el permiso separado hace explícita esa
 * asimetría en vez de dejarla en un comentario.
 */
export enum ClientAppPermission {
  /** Ver el listado de cuentas de la app y el detalle de una: accesos, dispositivos, bitácora. */
  ReadClientAppAccounts = 'ReadClientAppAccounts',
  /**
   * Abrir cuentas, conceder y revocar inmuebles, reenviar la invitación, corregir el
   * correo y cerrar sesiones. Varias de estas acciones TERMINAN EN EL BUZÓN de una
   * persona real.
   */
  ManageClientAppAccess = 'ManageClientAppAccess',
  /** Bloquear y reactivar una cuenta. Bloquear mata todas sus sesiones en el acto. */
  BlockClientAppAccount = 'BlockClientAppAccount'
}

export enum AvailabilityPermission {
  ReadAvailability = 'ReadAvailability',
  CreateReservation = 'CreateReservation',
  ManageReservations = 'ManageReservations',
  ReadReservationHistory = 'ReadReservationHistory',
  ReadInventoryComments = 'ReadInventoryComments',
  CreateInventoryComment = 'CreateInventoryComment',
  ManageInventoryComments = 'ManageInventoryComments'
}

export enum ClientConfigPermission {
  ReadClientConfig = 'ReadClientConfig',
  UpdateClientConfig = 'UpdateClientConfig'
}

export enum TemplatesPermission {
  CreateTemplate = 'CreateTemplate',
  ReadTemplate = 'ReadTemplate',
  UpdateTemplate = 'UpdateTemplate',
  DeleteTemplate = 'DeleteTemplate'
}

export enum PortalRequestsPermission {
  /** Crear/enviar una solicitud de verificación (flujo) al cliente */
  CreatePortalRequest = 'CreatePortalRequest',
  /** Listar solicitudes, ver detalle y métricas de revalidación */
  ReadPortalRequests = 'ReadPortalRequests',
  /** Revisar campos, take-over, pedir correcciones, editar campos y docs del expediente */
  ReviewPortalRequest = 'ReviewPortalRequest',
  /** Aprobar el expediente y sincronizar (merge) al registro interno del cliente */
  ApprovePortalRequest = 'ApprovePortalRequest',
  /** Rechazar el expediente completo */
  RejectPortalRequest = 'RejectPortalRequest',
  /** Cancelar el flujo (revocar el enlace) */
  RevokePortalRequest = 'RevokePortalRequest',
  /** Renovar un enlace vencido */
  ExtendPortalLink = 'ExtendPortalLink',
  /**
   * ☠️ Ver el enlace del portal en pantalla —para compartirlo por fuera del correo— y rotarlo.
   *
   * NO viaja con `ReadPortalRequests` ni con `ExtendPortalLink`, y la distinción es de riesgo, no
   * de trámite: leer muestra el KYC a alguien que YA se autenticó; esto entrega una llave que abre
   * ese KYC a cualquiera que la tenga, **sin autenticarse**. Son cosas distintas y la organización
   * tiene que poder dar una sin la otra.
   */
  RevealPortalLink = 'RevealPortalLink',
  /** Eliminar correcciones/comentarios de OTROS revisores (las propias siempre se pueden) */
  DeleteOthersCorrections = 'DeleteOthersCorrections'
}

export enum FlowDefinitionsPermission {
  ReadFlowDefinitions = 'ReadFlowDefinitions',
  CreateFlowDefinitions = 'CreateFlowDefinitions',
  UpdateFlowDefinitions = 'UpdateFlowDefinitions',
  DeactivateFlowDefinitions = 'DeactivateFlowDefinitions'
}

/**
 * Historial de versiones de expedientes (ADR 0029).
 *
 * Van SEPARADOS de los permisos de lectura y edición del expediente, y es a propósito:
 *
 * - **Ver el historial es más que ver el expediente.** Contiene estados anteriores, incluidos
 *   datos que alguien corrigió justamente porque estaban mal o no correspondía que estuvieran.
 * - **Poder editar no es poder rebobinar.** Restaurar deshace el trabajo de otra persona, así
 *   que se concede aparte de `UpdateClient` / `UpdateNegotiation`.
 *
 * Nacen SIN ASIGNAR a ningún rol: no hay migración que los siembre. Hasta que alguien los
 * conceda a mano desde la matriz de roles, el historial no lo ve nadie.
 *
 * ── POR QUÉ SON CUATRO Y NO DOS ──────────────────────────────────────────────
 *
 * Un par por dominio, y no un par genérico para los dos. El riesgo de cada historial no se
 * parece en nada al del otro:
 *
 * - El de un **cliente** conserva KYC: documento de identidad, patrimonio declarado, y sobre
 *   todo los datos que alguien corrigió PORQUE no correspondía que estuvieran. El historial los
 *   guarda igual, así que leerlo es leer lo que se quiso borrar.
 * - El de una **negociación** es información comercial del expediente.
 *
 * Que alguien pueda auditar cambios comerciales no implica que deba poder leer el patrimonio
 * viejo de una persona. Con un permiso único, conceder lo primero regalaba lo segundo.
 *
 * El backend ya estaba separado —son dos controllers, `v2-admin-clients` y
 * `v2-admin-negotiations`, cada uno con su ruta de versiones—; lo que faltaba era que el
 * permiso acompañara esa división.
 *
 * Const object en vez de `enum` porque es código nuevo — el resto de este archivo es deuda
 * que se migra en un track aparte.
 */
export const EntityVersionsPermission = {
  ReadClientVersions: 'ReadClientVersions',
  RestoreClientVersion: 'RestoreClientVersion',
  ReadNegotiationVersions: 'ReadNegotiationVersions',
  RestoreNegotiationVersion: 'RestoreNegotiationVersion'
} as const
export type EntityVersionsPermission =
  (typeof EntityVersionsPermission)[keyof typeof EntityVersionsPermission]

/**
 * El trámite de CRÉDITO de una negociación cerrada: 7 etapas con checklist, los 4 a 6 meses que
 * van de la promesa firmada al desembolso.
 *
 * ── TODOS LEEN, ADMINISTRACIÓN OPERA ─────────────────────────────────────────
 *
 * Esa es la regla del negocio (R6), y es la que explica por qué los permisos de consulta están
 * solos de un lado y los cuatro de operación del otro. El vendedor consulta el trámite de su
 * cliente —«¿en qué va el crédito?» es la pregunta que hoy se contesta por teléfono— pero no lo
 * opera.
 *
 * ── ⚠️ «TODOS LEEN» NO ES «TODOS LEEN TODO»: SON DOS PERMISOS ────────────────
 *
 * `ReadAllCredits` nació siendo el único permiso de lectura, así que **la puerta del módulo y el
 * alcance de la consulta eran el mismo tilde**: para que un asesor viera el trámite de su cliente
 * había que darle el tablero entero. El negocio pidió lo contrario —«los asesores solo visualizan
 * sus propios registros, acceso total únicamente al gerente de ventas»—, y con un solo permiso eso
 * no se puede expresar: quitarlo dejaba al asesor sin módulo.
 *
 * Se separa en el mismo par que ya tiene Negociaciones —lo propio contra todo—, sólo que allá el
 * lado «lo propio» nunca necesitó permiso porque `CreateNegotiation`/`UpdateNegotiation` ya abren
 * la pantalla. Acá el asesor NO opera el trámite (R6), así que no hay ningún otro permiso suyo que
 * pueda hacer de puerta: el lado propio tiene que existir como permiso.
 *
 * | | ve el módulo | qué filas |
 * | --- | --- | --- |
 * | `ReadCredits` | sí | las de su cartera, más lo que creó |
 * | `ReadAllCredits` | sí | todas |
 *
 * `ReadAllCredits` **no implica** `ReadCredits` en el código: los dos abren la pantalla y el
 * alcance lo decide `creditScopeFilter` mirando si el segundo está. La migración de roles los
 * reparte juntos donde corresponde, que es donde esa relación se declara.
 *
 * ── POR QUÉ NO ES UN SOLO `ManageCredits` ────────────────────────────────────
 *
 * Porque avanzar una etapa no se parece a llenar una checklist:
 *
 * - **`AdvanceCreditStage`** cierra una etapa y abre la siguiente. El proceso avisa pero no frena
 *   (R3), así que quien avanza puede dejar atrás ítems sin marcar: es la decisión de dar por
 *   cerrado un tramo, no de anotar un dato.
 * La modalidad y cualquier futura decisión de ruta son campos de la checklist. Separar el permiso
 * de la bifurcación duplicaba la autorización del mismo dato según qué versión de plantilla lo
 * mostrara. Los avisos tampoco son una acción manual del expediente: quien administra y publica la
 * plantilla decide sus destinatarios; al ejecutar, el proceso cumple esa versión publicada. El
 * apagado de emergencia sigue siendo el interruptor explícito `FEATURE_CREDIT_CLIENT_NOTICES`.
 *
 * `ManageCreditTemplates` es de otra naturaleza que los cuatro de operación: no toca un expediente,
 * cambia las reglas con las que van a nacer TODOS los próximos. Editar la plantilla es trabajo de
 * configuración, no de trámite.
 *
 * Const object en vez de `enum` porque es código nuevo — el resto de este archivo es deuda que se
 * migra en un track aparte.
 */
export const CreditsPermission = {
  /**
   * Ver el módulo y los expedientes PROPIOS: los de las negociaciones donde uno es el asesor, más
   * las que uno creó. Es el permiso base de lectura — lo necesita todo el que consulte el trámite.
   */
  ReadCredits: 'ReadCredits',
  /** Ver los expedientes de TODA la organización, no sólo la cartera propia. */
  ReadAllCredits: 'ReadAllCredits',
  /** Abrir el expediente a mano, sin esperar al disparo automático. */
  StartCreditProcess: 'StartCreditProcess',
  /** Marcar ítems y responder los campos que capturan. Es el trabajo diario del proceso. */
  UpdateCreditChecklist: 'UpdateCreditChecklist',
  /** Cerrar una etapa y abrir la siguiente, incluso con ítems pendientes. */
  AdvanceCreditStage: 'AdvanceCreditStage',
  /** Subir y quitar los archivos que piden los ítems (cartas, solvencias, facturas). */
  ManageCreditDocuments: 'ManageCreditDocuments',
  /** Editar y publicar la plantilla del proceso: cambia las reglas de los expedientes futuros. */
  ManageCreditTemplates: 'ManageCreditTemplates'
} as const
export type CreditsPermission = (typeof CreditsPermission)[keyof typeof CreditsPermission]

export const Permission = {
  ...ClientsPermission,
  ...UsersPermission,
  ...RolesPermission,
  ...CompaniesPermission,
  ...AgenciesPermission,
  ...RepresentantsPermission,
  ...CountriesPermission,
  ...StatesPermission,
  ...StateTransitionPermission,
  ...WorkflowsPermission,
  ...ProfessionsPermission,
  ...SocietiesPermission,
  ...ProjectsPermission,
  ...TypePropertiesPermission,
  ...PropertiesPermission,
  ...NegotiationsPermission,
  ...DeliveriesPermission,
  ...AvailabilityPermission,
  ...DocumentsPermission,
  ...ClientAppPermission,
  ...ClientConfigPermission,
  ...TemplatesPermission,
  ...PortalRequestsPermission,
  ...FlowDefinitionsPermission,
  ...EntityVersionsPermission,
  ...CreditsPermission
}

export type Permission =
  | ClientsPermission
  | UsersPermission
  | RolesPermission
  | CompaniesPermission
  | AgenciesPermission
  | RepresentantsPermission
  | CountriesPermission
  | StatesPermission
  | StateTransitionPermission
  | WorkflowsPermission
  | ProfessionsPermission
  | SocietiesPermission
  | ProjectsPermission
  | PropertiesPermission
  | TypePropertiesPermission
  | NegotiationsPermission
  | DeliveriesPermission
  | AvailabilityPermission
  | DocumentsPermission
  | ClientAppPermission
  | ClientConfigPermission
  | TemplatesPermission
  | PortalRequestsPermission
  | FlowDefinitionsPermission
  | EntityVersionsPermission
  | CreditsPermission

/** @deprecated use Permission instead */
export type typePermission = Permission
